import { language as lan_bankTransferIntroSteps } from "./bank-transfer-intro-steps";
import { language as lan_websiteBankTransferInfo } from "./website-bank-transfer-info";

let language = {
    ...lan_bankTransferIntroSteps,
    ...lan_websiteBankTransferInfo,
    BANK_TRANSFER_INTRO_TITLE: "Pay via Wire/Bank Transfer",
    BANK_TRANSFER_INTRO_DES1: "To complete your payment, simply follow these two easy steps to transfer the total order amount from your bank to our account.",
    BANK_TRANSFER_INTRO_ORDER_NO_TITLE: "{{website}} Order Number:",
    BANK_TRANSFER_INTRO_BANK_INFO_TITLE: "{{website}} Bank Information:",
    BANK_TRANSFER_INTRO_CONTACT_US:"Contact us",
    BANK_TRANSFER_INTRO_DES2:"If you have any questions or need assistance, feel free to reach out to us at {{supportEmail}}.",
    BANK_TRANSFER_INTRO_DES3:"Thank you for your order!",

    /*************************** 参数校验 *************************/
    // 地址参数校验提示
    BANK_TRANSFER_INTRO_URL_INVALID_PARAM_TITLE: "Invalid URL",
    // 地址参数缺失
    BANK_TRANSFER_INTRO_URL_PARAM_MISSING_CONTENT: "The bank transfer introduction URL is invalid. Please return to the previous page and try again. If you need further assistance, feel free to contact our support team at {{supportEmail}}.",
    BANK_TRANSFER_INTRO_LOADING_TITLE: "Page Loading Issue",
    BANK_TRANSFER_INTRO_LOADING_CONTENT1: "An issue occurred while loading this page. Please refresh the page and try again. If the problem persists, feel free to contact our support team at {{supportEmail}}.",
    // 订单不存在
    BANK_TRANSFER_INTRO_PAGE_LOADING_CONTENT2: "Order not found. Please double-check the URL and refresh the page to try again. If you need further assistance, feel free to contact our support team at {{supportEmail}}.",
};

export { language }